"use strict";

exports.__esModule = true;
var _SearchInput = require("./SearchInput");
Object.keys(_SearchInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchInput[key]) return;
  exports[key] = _SearchInput[key];
});
var _DebouncedSearchInput = require("./DebouncedSearchInput");
Object.keys(_DebouncedSearchInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DebouncedSearchInput[key]) return;
  exports[key] = _DebouncedSearchInput[key];
});